import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { JournalAddRequest } from "@/api/models/journal/JournalAddRequest";
import { JournalListRequest } from "@/api/models/journal/JournalListRequest";
import { JournalListResponse } from "@/api/models/journal/JournalListResponse";
import { JournalUpdateRequest } from "@/api/models/journal/JournalUpdateRequest";

export class JournalService {
  public static Add(body: JournalAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/journal",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/journal",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/journal/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: JournalUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/journal",
      body: body,
    });
  }

  public static ListAll(
    body: JournalListRequest
  ): CancelablePromise<JournalListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/journal",
      body: body,
    });
  }
}
